export default class ChannelMedia{

    static getInstance() {
        if (this.instance == null) {
            this.instance = new ChannelMedia();
        }
        return this.instance;
    }
    clear(){
        localStorage.removeItem("channel");
        localStorage.removeItem("trackId");
        localStorage.removeItem("mode");
    }
    initChannel(value){
        const params = new URLSearchParams(value);
        if(params.get("channel")!=null){
            localStorage.setItem("channel",params.get("channel"));
        }
        if(params.get("trackId")!=null){
            localStorage.setItem("trackId",params.get("trackId"));
        }
        if(params.get("mode")!=null){
            localStorage.setItem("mode",params.get("mode"));
        }
    }
    get isLeap(){
        let channel = localStorage.getItem("channel");
        if(channel=="leaplearner"){
            return true;
        }
        return false;
    }
    get isStudyLeap(){
        let channel = localStorage.getItem("channel");
        if(channel=="icodestudy"){
            return true;
        }
        return false;
    }

    get trackId(){
        let trackId = localStorage.getItem("trackId");
        if(!trackId){
            return 9002;
        }
        return trackId;
    }
    get mode(){
        let mode = localStorage.getItem("mode");
        if(!mode){
            return 0;
        }
        return mode;
    }
}


// WEBPACK FOOTER //
// ./src/utils/ChannelMedia.js